"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var roleApi = _interopRequireWildcard(require("@/api/role.js"));
var _validate = require("@/utils/validate");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var PROTECTED_MENU_NAME = '运营配置';
var _default = exports.default = {
  name: "roleEdit",
  props: {
    isCreate: {
      type: Number,
      required: true
    },
    editData: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    var validateRoleName = function validateRoleName(rule, value, callback) {
      var name = (value || '').trim();
      if (!name) {
        callback(new Error('请填写角色名称'));
        return;
      }
      if (name === '超级管理员') {
        callback(new Error('不能使用「超级管理员」作为角色名称'));
        return;
      }
      callback();
    };
    return {
      pram: {
        roleName: null,
        menuIds: '',
        status: true,
        id: null
      },
      roleNameRules: [{
        required: true,
        validator: validateRoleName,
        trigger: ['blur', 'change']
      }],
      menuExpand: false,
      menuOptions: [],
      checkStrictly: false,
      defaultProps: {
        children: "childList",
        label: "name"
      },
      protectedRootIds: []
    };
  },
  mounted: function mounted() {
    this.initEditData();
    this.getCacheMenu();
  },
  methods: {
    close: function close() {
      this.$emit('hideEditDialog');
    },
    idKey: function idKey(id) {
      return id == null ? '' : String(id);
    },
    isProtected: function isProtected(data) {
      if (!data) return false;
      return this.protectedRootIds.indexOf(this.idKey(data.id)) !== -1 || this.isUnderProtectedRoot(data.id, this.menuOptions);
    },
    isUnderProtectedRoot: function isUnderProtectedRoot(targetId, nodes) {
      var target = this.idKey(targetId);
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (this.protectedRootIds.indexOf(this.idKey(node.id)) !== -1) {
          if (this.isNodeOrDescendant(node, target)) return true;
        }
        if (node.childList && node.childList.length) {
          if (this.isUnderProtectedRoot(targetId, node.childList)) return true;
        }
      }
      return false;
    },
    isNodeOrDescendant: function isNodeOrDescendant(node, targetKey) {
      if (this.idKey(node.id) === targetKey) return true;
      if (!node.childList || !node.childList.length) return false;
      for (var i = 0; i < node.childList.length; i++) {
        if (this.isNodeOrDescendant(node.childList[i], targetKey)) return true;
      }
      return false;
    },
    collectProtectedRoots: function collectProtectedRoots(nodes) {
      var ids = [];
      var walk = function walk(list) {
        for (var i = 0; i < list.length; i++) {
          var n = list[i];
          if (n.name === PROTECTED_MENU_NAME) {
            ids.push(String(n.id));
          }
          if (n.childList && n.childList.length) walk(n.childList);
        }
      };
      walk(nodes || []);
      this.protectedRootIds = ids;
    },
    protectOperationConfig: function protectOperationConfig() {
      var _this = this;
      this.$nextTick(function () {
        _this.traverseAndProtect(_this.menuOptions);
      });
    },
    traverseAndProtect: function traverseAndProtect(nodes) {
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        var treeNode = this.$refs.menu.getNode(node.id);
        if (treeNode && this.isProtected(node)) {
          // deep=true：保护子树整支勾上（严格模式下也不会误伤其它分支）
          this.$refs.menu.setChecked(node.id, true, true);
          treeNode.expanded = false;
        }
        if (node.childList && node.childList.length) {
          this.traverseAndProtect(node.childList);
        }
      }
    },
    handleCheckChange: function handleCheckChange(data, checked) {
      if (this.isProtected(data) && !checked) {
        this.$message({
          message: '运营配置为系统必选权限，不可取消',
          type: 'warning',
          duration: 2200
        });
        var _this = this;
        this.$nextTick(function () {
          _this.$refs.menu.setChecked(data.id, true, true);
        });
      }
    },
    handleNodeClick: function handleNodeClick(data, node) {
      if (this.isProtected(data)) {
        node.expanded = false;
        return false;
      }
    },
    handleNodeExpand: function handleNodeExpand(data) {
      if (this.isProtected(data)) {
        var node = this.$refs.menu.getNode(data.id);
        if (node) node.expanded = false;
      }
    },
    /**
     * 回显只勾叶子；半选父级 id 不直接 set，交给 el-tree 算成「-」
     * （若把半选父 id 也 setChecked，会变成全勾并级联全选子节点）
     */
    collectParentIdSet: function collectParentIdSet(nodes, set) {
      if (!nodes || !nodes.length) return set;
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.childList && n.childList.length) {
          set[this.idKey(n.id)] = true;
          this.collectParentIdSet(n.childList, set);
        }
      }
      return set;
    },
    applyCheckedMenuIds: function applyCheckedMenuIds(menuIds) {
      var _this = this;
      var parentMap = this.collectParentIdSet(this.menuOptions, {});
      var leafKeys = (menuIds || []).map(function (id) {
        return String(id);
      }).filter(function (id) {
        return !parentMap[id];
      });
      this.checkStrictly = false;
      this.$nextTick(function () {
        if (_this.$refs.menu) {
          _this.$refs.menu.setCheckedKeys(leafKeys);
        }
        _this.protectOperationConfig();
      });
    },
    initEditData: function initEditData() {
      if (this.isCreate !== 1) return;
      var edit = this.editData;
      this.pram.roleName = edit.roleName;
      this.pram.status = edit.status;
      this.pram.id = edit.id;
      var loading = this.$loading({
        lock: true,
        text: '加载中'
      });
      var _this = this;
      roleApi.getInfo(edit.id).then(function (res) {
        _this.menuOptions = res.menuList || [];
        _this.collectProtectedRoots(_this.menuOptions);
        loading.close();
        _this.$nextTick(function () {
          _this.applyCheckedMenuIds(res.menuIds || []);
        });
      });
    },
    getCacheMenu: function getCacheMenu() {
      if (this.isCreate !== 0) return;
      var loading = this.$loading({
        lock: true,
        text: '加载中'
      });
      var _this = this;
      roleApi.menuCacheList().then(function (res) {
        _this.menuOptions = res || [];
        _this.collectProtectedRoots(_this.menuOptions);
        loading.close();
        _this.$nextTick(function () {
          _this.protectOperationConfig();
        });
      });
    },
    handlerSubmit: (0, _validate.Debounce)(function (form) {
      var _this = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        _this.pram.menuIds = _this.getMenuAllCheckedKeys().join(',');
        if (_this.isCreate === 0) {
          _this.handlerSave();
        } else {
          _this.handlerEdit();
        }
      });
    }),
    handlerSave: function handlerSave() {
      var _this = this;
      roleApi.addRole(this.pram).then(function () {
        _this.$message.success('创建身份成功');
        _this.$emit('hideEditDialog');
      });
    },
    handlerEdit: function handlerEdit() {
      var _this = this;
      roleApi.updateRole(this.pram).then(function () {
        _this.$message.success('更新身份成功');
        _this.$emit('hideEditDialog');
      });
    },
    getMenuAllCheckedKeys: function getMenuAllCheckedKeys() {
      var checked = this.$refs.menu.getCheckedKeys();
      var half = this.$refs.menu.getHalfCheckedKeys();
      return checked.concat(half);
    },
    handleCheckedTreeExpand: function handleCheckedTreeExpand(value) {
      var _this = this;
      this.menuOptions.forEach(function (item) {
        var node = _this.$refs.menu.getNode(item.id);
        if (node) {
          node.expanded = value && !_this.isProtected(item);
        }
      });
    }
  }
};